import React, { useState,useEffect } from "react";
import Header from "../page/header";
import Footer from "../page/footer";
import { useDispatch } from 'react-redux';
import { alarmYN } from '../features/admin/adminSlice';
import "../App.css";
import "../css/default.css";
import "../css/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import '@fortawesome/fontawesome-free/js/all.js'

const AppLayout = ({ children }) => {
  
  const [showScroll, setShowScroll] = useState(false);
  const dispatch = useDispatch();

  // 스크롤 이벤트 핸들링
  const checkScrollTop = () => {
    if (!showScroll && window.scrollY > 500) {
      setShowScroll(true);
    } else if (showScroll && window.scrollY <= 500) {
      setShowScroll(false);
    }
  };

 // 스크롤 맨 위로 이동
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // 스크롤 이동
  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [showScroll]);


useEffect(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        //console.log('Service Worker 등록 성공:', reg);
      })
      .catch(err => {
        //console.log('Service Worker 등록 실패:', err);
      });
  }

  if ('Notification' in window && Notification.permission !== 'granted') {
    Notification.requestPermission().then(permission => {
      //console.log('알림 권한 상태:', permission);
    });
  }
}, []);


  // 알림 전송 함수
  // const sendNotificationToUser = async () => {
  //   const reg = await navigator.serviceWorker.ready;

  //   reg.showNotification("테스트 알림", {
  //     body: "이 알림은 현재 사용자의 브라우저에만 나타납니다.",
  //     icon: "/logo192.png", 
  //     data: { url: process.env.REACT_APP_SITE_URL },
  //   });
  // };

  const sendNotification = async () => {

    const adminString = sessionStorage.getItem("admin");
    const admin = adminString ? JSON.parse(adminString) : null;
    const userId = admin?.user_id;

    const resultAction = await dispatch(alarmYN({ id: userId }));

    if (alarmYN.fulfilled.match(resultAction)) {
      const alarmYNValue = resultAction.payload.admin.alarmYN;
      if (alarmYNValue === 'Y') {

        // sendNotificationToUser();
      } else {
        //console.log('알림 설정이 꺼져 있습니다.');
      }
    } else {
      console.error('alarmYN 확인 실패:', resultAction.payload);
    }
  };


  return (
    <>
      <Header />
      {children}
      <Footer/>
      {/* <div 
        className="scrollTop2"
        onClick={sendNotification}
      >
        <span>
          <i className="">알림</i>
        </span>
      </div> */}
      <div 
        className={`scrollTop ${showScroll ? 'visible' : ''}`}
        onClick={scrollTop}
      >
        <span>
          <i className="fa-solid fa-arrow-up"></i>
        </span>
      </div>
    </>
  );
};

export default AppLayout;